import { render, staticRenderFns } from "./CheckboxGroup-gt3.vue?vue&type=template&id=0fa52f05"
import script from "./CheckboxGroup-gt3.vue?vue&type=script&lang=js"
export * from "./CheckboxGroup-gt3.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports